import { saga } from 'modules/app'

export default saga



// WEBPACK FOOTER //
// ./client/base/saga.js